import { render, staticRenderFns } from "./MaskInput.vue?vue&type=template&id=fddd2322"
import script from "./MaskInput.vue?vue&type=script&lang=js"
export * from "./MaskInput.vue?vue&type=script&lang=js"
import style0 from "./MaskInput.vue?vue&type=style&index=0&id=fddd2322&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports